<template>
  <div class="box is-boxed-3">
    <article class="media post-header variant-one" style="margin-bottom: 28px;">
      <figure class="media-left">
        <nuxt-link :to="{name: 'profile-username', params: {username: !isEmpty(post.user) ? post.user.email : ''}}">
          <div class="image is-48x48 is-circle" style="overflow: hidden;">
            <avatar :avatar_url="getPostAvatar(post)"></avatar>
          </div>
        </nuxt-link>
      </figure>
      <div class="media-content">
        <div>
          <span class="font-14 font-w-600 has-text-darkblue" :data-tooltip="getPostAuthor(post)">
            <a href="" @click.prevent="openAuthorPage">{{ getPostAuthor(post) }}</a>
          </span>
          <span class="font-14 font-w-400 has-text-neutralgray1">{{ getActDesc(post) }}</span>
          <span v-if="!isEmpty(post.groupTeam)" class="font-14 font-w-400">
            <figure
              class="image is-16x16"
              style="display: inline-block;">
              <img :src="'/assets/img/icon/chevron-right-12x12.svg'" style="margin-top: 4px;" />
            </figure>
            <nuxt-link class="has-text-primary" :to="{ path: `/panel/classes/${group.id}/groupteams/${post.groupTeam.id}/discussion` }" v-if="group.type == 'A'">{{ post.groupTeam.name }}</nuxt-link>
            <nuxt-link class="has-text-primary" :to="{ path: `/panel/groups/${group.id}/groupteams/${post.groupTeam.id}/discussion` }" v-else-if="group.type != 'A'">{{ post.groupTeam.name }}</nuxt-link>
          </span>
          <span v-if="!isEmpty(post.section)" class="font-14 font-w-400">
            <figure
              class="image is-16x16"
              style="display: inline-block;">
              <img :src="'/assets/img/icon/chevron-right-12x12.svg'" style="margin-top: 4px;" />
            </figure>
            <nuxt-link class="has-text-primary" :to="{ path: `/panel/classes/${group.id}/sections/${post.section.id}` }" v-if="!isEmpty(post.section) && group.type == 'A'">Sesi ke {{ post.section.meet }}</nuxt-link>
            <nuxt-link class="has-text-primary" :to="{ path: `/panel/groups/${group.id}/sections/${post.section.id}` }" v-else-if="!isEmpty(post.section) && group.type != 'A'">Sesi ke {{ post.section.meet }}</nuxt-link>
          </span>
          <span class="font-14 font-w-400 has-text-primary">
            <figure
              class="image is-16x16"
              style="display: inline-block;">
              <img :src="'/assets/img/icon/chevron-right-12x12.svg'" style="margin-top: 4px;" />
            </figure>
            <a href="" class="has-text-primary" @click.prevent="toDetailGroup(post)">{{ filterSymbol(group.name) }}</a>
          </span>
        </div>
        <div>
          <span class="font-14 font-w-400 has-text-neutralgray2">{{ date_humanize(post.updatedAt) }}</span>
        </div>
      </div>

      <div class="media-right" v-if="(!isEmpty(auth) && post.userId == auth.id) || (isAdmin && !isEmpty(account) && account.university.id == group.universityId) || (['O', 'A'].indexOf(group.groupMemberRole) > -1)">
        <div class="columns is-mobile" style="margin-bottom: 0;">
          <div class="column is-narrow">
            <b-dropdown hoverable aria-role="list">
              <button class="button is-small is-text" slot="trigger">
                <span class="icon">
                  <b-icon icon="dots-horizontal"></b-icon>
                </span>
              </button>

              <b-dropdown-item aria-role="listitem" @click="edit(post)">
                <span class="icon"><i class="fas fa-edit"></i></span>
                <span>Ubah</span>
              </b-dropdown-item>
              <hr class="dropdown-divider">
              <b-dropdown-item aria-role="listitem" @click="deletePost(post.id)">
                <span class="icon"><i class="fas fa-trash"></i></span>
                <span>Hapus</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </article>

    <custom-carousel v-if="!isEmpty(post.cover) && post.type != '1'"
      style="margin: 0 0 12px;"
      figureStyles="border-radius: 8px;"
      :items="[{type: 'image', link_source: post.cover, link_thumb: post.cover}]"
    ></custom-carousel>
    <div :class="{'box is-box-post': post.conferenceType == 'GMEET'}">
    <h3 v-if="['Z', 'Q', '1'].indexOf(post.type) <= -1" class="post-title" :style="post.conferenceType !== 'GMEET' ? 'margin-bottom: 10px;' : ''">
      <a href="" class="has-text-darkblue font-20 font-w-600" @click.prevent="group.type == 'A' ? toDetailPost(post, 'classes') : toDetailPost(post, 'groups')">{{ post.title }}</a>
    </h3>
    <p v-if="['V'].indexOf(post.type) > -1 && post.conferenceType == 'GMEET' && !isEmpty(post.section)" class="font-poppins font-14 has-text-neutralgray3" style="margin-bottom: 16px;">Sesi {{ post.section.meet }} • {{ dateSectionFormat(post.section.startedAt, post.section.endedAt) }}</p>
    <div v-if="['Z', 'Q', '1'].indexOf(post.type) <= -1" class="content timeline-content">
      <pre class="font-secondary font-14" style="background: transparent; padding: 0; white-space: inherit; margin-bottom: 0;" v-html="!is_truncate ? post.description : post.excerpt"></pre>

      <div v-if="!is_truncate">
        <br v-if="['G', 'P', '0', 'D'].indexOf(post.type) > -1">
        <p v-if="['G', 'P', '0', 'D'].indexOf(post.type) > -1" style="word-break: break-all;"><small>Sumber: <a :href="post.extUrl" target="_blank" rel="noopener" class="has-text-link">{{ post.extUrl }}</a></small></p>
        <br v-if="['G', 'P', '0', 'D'].indexOf(post.type) > -1">
      </div>

      <div v-if="!isEmpty(post.excerpt)" class="font-14 font-w-600">
        <spinner-loading v-if="loading_get_description"></spinner-loading>
        <a v-else-if="is_truncate" @click.prevent="seeMore(post.id)" href="" class="has-text-secondary font-14 font-w-600">Baca Selengkapnya...</a>
        <a v-else @click.prevent="is_truncate = true" href="" class="has-text-secondary font-14 font-w-600">Sembunyikan</a>
      </div>
    </div>

    <div v-if="post.type == 'S' && post.survey !== undefined && post.survey !== null">
      <br>
      <div class="columns is-mobile is-vcentered" style="margin-bottom: 0;" v-for="(choice, key) in post.survey.choices" :key="key">
        <div class="column is-narrow">
          <div class="field">
            <b-checkbox v-model="selected_choices" @input="addChoice(post.survey, choice)" :native-value="choice.id"></b-checkbox>
            <label :for="`c-${choice.id}-${key}`" style="padding-left: 0;"></label>
          </div>
        </div>
        <div class="column">
          <a @click.prevent="addChoice(post.survey, choice)" class="has-text-dark font-14" style="text-decoration: none;">{{ choice.name }}</a>
        </div>
        <div class="column has-text-right is-narrow">
          <p class="font-w-600">
            <span v-if="choice.userCount && choice.totalUniqueVoters && choice.userCount > 0 && choice.totalUniqueVoters > 0">{{ (choice.userCount / choice.totalUniqueVoters * 100).toFixed(0) }}</span>
            <span v-else>0</span>%
          </p>
        </div>
      </div>

      <p class="font-w-600" style="margin-top: 10px;">{{ !isEmpty(post.survey.choices[0]) ? post.survey.choices[0].totalUniqueVoters : 0 }} Peserta Memilih</p>
    </div>

    <div v-else-if="post.type == 'E'" class="columns" style="margin-top: 5px;">
      <div class="column is-4-fullhd is-4-widescreen is-4-desktop is-4-tablet is-12-mobile" style="border-right: 1px solid #E5E5E5;">
        <h3><i class="fa fa-calendar"></i>&nbsp;TANGGAL</h3>
        <p style="font-size: 13px;">{{ post.event ? getFormattedDate(post.event.startAt) : '' }}</p>
      </div>
      <div class="column is-4-fullhd is-4-widescreen is-4-desktop is-4-tablet is-12-mobile" style="border-right: 1px solid #E5E5E5;">
        <div v-if="post.event !== null && post.event.endAt > 0 && post.event.endAt != null">
          <h3><i class="fa fa-calendar"></i>&nbsp;BERAKHIR PADA</h3>
          <p style="font-size: 13px;">{{ post.event ? getFormattedDate(post.event.endAt) : '' }}</p>
        </div>
        <div v-if="post.event == null || post.event.endAt == null || post.event.endAt == 0 || post.event.endAt == -1">
          <h3>SELESAI</h3>
          <p style="font-size: 13px;">Selesai</p>
        </div>
      </div>
      <div class="column is-4-fullhd is-4-widescreen is-4-desktop is-4-tablet is-12-mobile">
        <h3><i class="fa fa-map-marker"></i>&nbsp;TEMPAT</h3>
        <p style="font-size: 13px;">{{ post.event.location }}</p>
      </div>
    </div>

    <div v-else-if="!isEmpty(post.quiz) && post.type == 'Z' && !isEmpty(post.section)">
      <div class="middle-content">
        <div class="tugas__content-timeline">
          <div class="content" style="margin-bottom: 0;">
            <img src="/assets/img/v1/icon/icon_ tugas.svg" class="icon-content" alt="">
            <div class="keterangan" style="width: 100%;">
              <div class="header-content">
                <div class="title-content">
                  <b-tooltip :label="post.title" type="is-dark">
                    <h6>
                      <a @click.prevent="group.type == 'A' ? toDetailPost(post, 'classes') : toDetailPost(post, 'groups')">{{ post.title }}</a>
                    </h6>
                  </b-tooltip>

                  <div class="columns">
                    <div class="column">
                      <p v-if="!isEmpty(post.quiz.finishedAt)" class="text-secondary">Batas waktu pengerjaan: {{ dateFormat(post.quiz.finishedAt, 'DD MMM YYYY . HH:mm') }}</p>
                      <p class="font-12" v-if="!isEmpty(post.quiz.finishedAt) && post.quiz.submittedAt <= 0"><vcountdown :finished="post.quiz.finishedAt"></vcountdown></p>
                    </div>
                  </div>
                </div>

                <div class="btn-upload">
                  <button class="button is-tugas" @click.prevent="group.type == 'A' ? toDetailPost(post, 'classes') : toDetailPost(post, 'groups')">
                    <span v-if="(['M'].indexOf(group.groupMemberRole) > -1) && post.quiz.submittedAt > 0">{{ post.quiz.grade }}</span>
                    <span v-else-if="(['O', 'A'].indexOf(group.groupMemberRole) > -1)">Lihat Hasil</span>
                    <span v-else-if="post.quiz.grade === null">Kerjakan Quiz</span>
                    <span v-else-if="post.quiz.submittedAt === 0">Selesaikan Quiz</span>
                  </button>
                </div>
              </div>

              <div class="desc">
                <span class="desc-title">{{ post.quiz.questionsCount }} Pertanyaan</span>
                <pre class="font-secondary font-12" style="background: transparent; padding: 0; white-space: pre-line; margin-bottom: 0;" v-html="!is_truncate ? post.description : post.excerpt"></pre>

                <div v-if="!isEmpty(post.excerpt)" class="font-14 font-w-600">
                  <spinner-loading v-if="loading_get_description"></spinner-loading>
                  <a v-else-if="is_truncate" @click.prevent="seeMore(post.id)" href="" class="has-text-secondary font-14 font-w-600">Baca Selengkapnya...</a>
                  <a v-else @click.prevent="is_truncate = true" href="" class="has-text-secondary font-14 font-w-600">Sembunyikan</a>
                </div>
              </div>

              <div class="file-download" v-for="(media, key) in file_medias" :key="key" style="padding: 5px 0;" :style="key == 0 ? '' : 'margin-top: 7px !important;'">
                <span>
                  &nbsp;&nbsp;<icon-collection :media="media" size="is-24x24"></icon-collection>
                  <a href="" @click.prevent="selectMedia(media)">{{ media.name }}</a>
                </span>
                <button class="button is-text" v-if="!isEmpty(auth) && ['O', 'A', 'M'].indexOf(group.groupMemberRole) > -1" @click.prevent="downloadPostMedia(media)">Unduh</button>
              </div>

              <div class="desc" v-if="!loading_get_quiz_ranks_refresh && !isEmpty(quiz_ranks)" style="margin-top: 15px;">
                <span class="desc-title">Papan Peringkat Quiz</span>
                <div style="overflow: auto; max-height: 300px; margin-top: 10px;">
                  <div class="box" style="padding: 10px 15px; margin-bottom: 0px; border-radius: 0;" v-for="(r, key) in quiz_ranks" :key="key" :style="(key + 1) == quiz_ranks.length ? 'margin-bottom: 15px;' : ''">
                    <div class="columns is-mobile is-vcentered">
                      <div class="column is-narrow">
                        <span class="tag" :class="{'is-warning': key == 0, 'is-light': key == 1, 'is-bronze': key == 2, 'is-white': key > 2, 'font-w-600 has-text-primary': post.group.groupMemberId == r.groupMemberId}">
                          {{ parseFloat(key) + 1 }}.
                        </span>
                      </div>

                      <div class="column is-narrow">
                        <p class="image is-32x32 is-circle">
                          <avatar :avatar_url="!isEmpty(r.avatar) ? r.avatar.thumb.link : null"></avatar>
                        </p>
                      </div>
                      <div class="column">
                        <p :class="{'font-w-600 has-text-primary': post.group.groupMemberId == r.groupMemberId}">{{ !isEmpty(r.namaMahasiswa) ? r.namaMahasiswa : r.namaUser }}</p>
                        <b-tooltip label="Durasi Pengerjaan" type="is-dark">
                          <p class="font-12 has-text-grey">{{ secondsToHms(r.duration) }}<span v-if="!isEmpty(r.universityName)"> | {{ r.universityName }}</span></p>
                        </b-tooltip>
                      </div>

                      <div class="column is-narrow">
                        <span class="tag is-light" :class="{'font-w-500 has-text-darkblue': post.group.groupMemberId != r.groupMemberId, 'is-medium font-w-600 has-text-primary': post.group.groupMemberId == r.groupMemberId}"><i class="fas fa-star has-text-warning"></i>&nbsp;&nbsp;{{ r.totalScore }}</span>
                      </div>
                    </div>
                  </div>

                  <spinner-loading v-if="loading_get_quiz_ranks"></spinner-loading>

                  <pagination v-if="!loading_get_quiz_ranks && !loading_get_quiz_ranks_refresh" :dataProvider="quizRankDataProvider" :clickHandler="fetchQuizRanks"></pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="post.type == 'V'" style="margin-bottom: 10px;">
      <div v-if="post.zoomStatus == 'ended'">
        <div v-if="!(!isEmpty(post.meet) && !isEmpty(post.meet.playVideoRecordingUrl))" class="box is-bg-primary has-text-centered is-no-box-shadow" style="margin: 0; border-radius: 8px; padding: 10px; border: none;">
          <p style="margin: 0;" class="has-text-white"><i class="fas fa-check"></i>&nbsp;Pertemuan telah selesai</p>
        </div>

        <div v-else>
          <div class="message is-primary" style="margin: 0;">
            <div class="message-body" style="padding: 15px;">
              Lihat ulang {{ ['O', 'A'].indexOf(group.groupMemberRole) > -1 ? 'perkuliahan Anda' : 'perkuliahanmu' }} melalui video url dibawah ini:
            </div>
          </div>

          <div class="middle-content">
            <div class="tugas__content-timeline">
              <div class="content" style="padding: 0; border: none; margin: 0;">
                <div class="file-download" style="padding: 5px 0; width: 100%;" v-if="(isAdmin && !isEmpty(account) && account.university.id == group.universityId) || !isEmpty(auth) && ['O', 'A', 'M'].indexOf(group.groupMemberRole) > -1 && !isEmpty(post.meet.playVideoRecordingUrl)">
                  <span>
                    <b-icon style="margin-left: 10px;" class="has-text-info" icon="video"></b-icon>
                    <a target="_blank" rel="noopener" :href="post.meet.playVideoRecordingUrl">Recording URL</a>
                  </span>
                  <a target="_blank" rel="noopener" :href="post.meet.playVideoRecordingUrl" class="button is-text">Lihat</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <a v-if="post.conferenceType == 'GMEET' && ['O', 'A'].indexOf(group.groupMemberRole) > -1 && post.userId === auth.id && isEmpty(post.gmeetUrl)" @click.prevent="startMeeting" class="box is-bg-primary has-text-centered is-no-box-shadow" style="margin: 0; border-radius: 8px; padding: 10px; border: none;">
          <p style="display: flex; margin: 0; justify-content: center;" class="font-w-600 has-text-white"><img src="/assets/img/icon/video-circle.svg" />&nbsp;Mulai Conference</p>
        </a>
        <a v-else-if="post.conferenceType == 'GMEET' && ['O', 'A'].indexOf(group.groupMemberRole) > -1 && post.userId !== auth.id && isEmpty(post.gmeetUrl)" @click.prevent="startMeeting" class="box is-bg-primary has-text-centered is-no-box-shadow" style="margin: 0; border-radius: 8px; padding: 10px; border: none;" :style="isEmpty(post.gmeetUrl)? 'background-color: #C2C2C2 !important; pointer-events: none;': ''">
          <p style="display: flex; margin: 0; justify-content: center;" class="font-w-600 has-text-white"><img src="/assets/img/icon/video-circle.svg" />&nbsp;Gabung Conference</p>
        </a>
        <a v-else-if="post.conferenceType == 'GMEET' && ['O', 'A'].indexOf(group.groupMemberRole) > -1 && !isEmpty(post.gmeetUrl)" @click.prevent="startMeeting" class="box is-bg-primary has-text-centered is-no-box-shadow" style="margin: 0; border-radius: 8px; padding: 10px; border: none;">
          <p style="display: flex; margin: 0; justify-content: center;" class="font-w-600 has-text-white"><img src="/assets/img/icon/video-circle.svg" />&nbsp;Gabung Conference</p>
        </a>
        <a v-else-if="post.conferenceType == 'GMEET' && ['M'].indexOf(group.groupMemberRole) > -1" @click.prevent="startMeeting" class="box is-bg-primary has-text-centered is-no-box-shadow" style="margin: 0; border-radius: 8px; padding: 10px; border: none;" :style="isEmpty(post.gmeetUrl)? 'background-color: #C2C2C2 !important; pointer-events: none;': ''">
          <p style="display: flex; margin: 0; justify-content: center;" class="font-w-600 has-text-white"><img src="/assets/img/icon/video-circle.svg" />&nbsp;Gabung Conference</p>
        </a>
        <a v-else-if="['O', 'A'].indexOf(group.groupMemberRole) > -1 && (isEmpty(post.zoomStatus) || post.zoomStatus == 'waiting')" @click.prevent="startMeeting" target="_blank" rel="noopener" class="button is-fullwidth is-large is-info has-text-white" :class="{'is-loading': loading_start_meeting}" :disabled="loading_start_meeting">
          <span class="icon">
            <i class="fas fa-chalkboard"></i>
          </span>
          <span><small>Mulai Conference</small></span>
        </a>
        <a v-else-if="['O', 'A'].indexOf(group.groupMemberRole) > -1 && (post.zoomStatus == 'started')" @click.prevent="startMeeting" target="_blank" rel="noopener" class="button is-fullwidth is-large is-info has-text-white" :class="{'is-loading': loading_start_meeting}" :disabled="loading_start_meeting">
          <span class="icon">
            <i class="fas fa-chalkboard"></i>
          </span>
          <span><small>Gabung ke Conference</small></span>
        </a>
        <div class="box is-bg-lighterblue has-text-centered" v-else-if="['M'].indexOf(group.groupMemberRole) > -1 && (isEmpty(post.zoomStatus) || post.zoomStatus == 'waiting')">
          <p style="margin: 0;"><i class="fas fa-spinner"></i>&nbsp;Pertemuan belum dimulai</p>
        </div>
        <a v-else-if="['M'].indexOf(group.groupMemberRole) > -1 && post.zoomStatus == 'started'" :href="group.type == 'A' ? `${post.zoomJoinUrl} + &uname=${account.name}|${account.userUniversityId}|${group.groupMemberId}` : `${post.zoomJoinUrl} + &uname=${auth.name}||${group.groupMemberId}`" target="_blank" rel="noopener" class="button is-fullwidth is-large is-bg-info has-text-white">
          <span class="icon">
            <i class="fas fa-chalkboard"></i>
          </span>
          <span><small>Gabung ke Conference</small></span>
        </a>
        <div class="box has-background-primary has-text-centered" v-else-if="post.zoomStatus == 'ended'">
          <p class="has-text-white"><i class="fas fa-check"></i>&nbsp;SELESAI</p>
        </div>
        <br v-if="!isEmpty(post.zoomStatus) && post.zoomStatus == 'started' && group.groupMemberRole == 'M'">

        <div v-if="!isEmpty(post.zoomStatus) && post.zoomStatus == 'started'">
          <b-field label="ID" v-if="group.groupMemberRole == 'M'">
            <b-input expanded :value="post.zoomMeetingId" readonly></b-input>
          </b-field>

          <b-field label="Password" v-if="group.groupMemberRole == 'M'">
            <b-input type="password" expanded :value="post.zoomPassword" readonly password-reveal></b-input>
          </b-field>

          <b-field label="Your Name" v-if="group.groupMemberRole == 'M'">
            <b-input v-if="group.type == 'A'" expanded :value="`${account.name}|${account.userUniversityId}|${group.groupMemberId}`" readonly></b-input>
            <b-input v-else expanded :value="`${auth.name}||${group.groupMemberId}`" readonly></b-input>
          </b-field>

          <p class="help has-text-grey" v-if="group.groupMemberRole == 'M'"><small>Untuk pencatatan tanda kehadiran, pastikan kolom <code>"Your Name"</code> pada ZOOM sesuai dengan kolom diatas.</small></p>
        </div>
        <p v-if="post.conferenceType == 'GMEET'" class="font-13 font-poppins has-text-grey3" style="margin-top: 12px;"><i class="fas fa-info-circle"></i> Video Conference menggunakan Google Meet {{ post.conferenceType == 'GMEET' && post.userId === auth.id ? `(${auth.gcalendarEmail})` : '' }}</p>
      </div>
    </div>

    <div v-else-if="!isEmpty(post.teacherQuestion) && ['Q', '1'].includes(post.type)" class="inner-post-content-container">
      <div style="padding: 24px;">
        <div class="columns is-mobile is-tablet is-mobile is-gapless">
          <div class="column is-narrow" style="margin-right: 12px;">
            <figure v-if="post.type == '1'"
              class="image is-48x48"
              style="overflow: hidden; margin: 0 auto;">
              <img style="width: 100%; height: 100%;" :src="'/assets/img/icon/team-task-48x48.svg'"/>
            </figure>
            <img v-else src="/assets/img/v1/icon/icon_ tugas.svg" class="icon-content" alt="">
          </div>
          <div class="column">
            <b-tooltip :label="post.title" type="is-dark">
              <a class="font-18 font-w-600 has-text-darkblue"
                @click.prevent="group.type == 'A' ? toDetailPost(post, 'classes') : toDetailPost(post, 'groups')">
                {{ post.title }}
              </a>
            </b-tooltip>
            <p class="font-14 font-w-400 has-text-blue">
              Batas tanggal & waktu pengumpulan: <span class="font-w-600">{{ dateFormat(post.teacherQuestion.dueDate, 'DD MMM YYYY HH:mm') }}</span>
            </p>
            <p class="font-12" v-if="!isEmpty(post.teacherQuestion.dueDate) && post.teacherQuestion.status == 'O'"><vcountdown :finished="post.teacherQuestion.dueDate"></vcountdown></p>
          </div>
          <div v-if="post.type == 'Q'" class="colum is-narrow">
            <button class="button is-secondary font-14 font-w-600" @click.prevent="group.type == 'A' ? toDetailPost(post, 'classes') : toDetailPost(post, 'groups')">
              <span v-if="(['M'].indexOf(group.groupMemberRole) > -1) && !isEmpty(post.teacherQuestion.grade) && post.teacherQuestion.grade != 0">{{ post.teacherQuestion.grade }}</span>
              <span v-else-if="(['O', 'A'].indexOf(group.groupMemberRole) > -1) || post.teacherQuestion.status != 'O'">Lihat Hasil</span>
              <span v-else>Kumpulkan Tugas</span>
            </button>
          </div>
        </div>
        <div class="columns">
          <div class="column is-full">
            <pre class="font-secondary font-12 content" style="background: transparent; padding: 0; white-space: pre-line; margin-bottom: 0;" v-html="!is_truncate ? post.description : post.excerpt"></pre>
            <div v-if="!isEmpty(post.excerpt)" class="font-14 font-w-600">
              <spinner-loading v-if="loading_get_description"></spinner-loading>
              <a v-else-if="is_truncate" @click.prevent="seeMore(post.id)" href="" class="has-text-secondary font-14 font-w-600">Baca Selengkapnya...</a>
              <a v-else @click.prevent="is_truncate = true" href="" class="has-text-secondary font-14 font-w-600">Sembunyikan</a>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-full" style="padding: 12px 24px;">
            <div v-for="(media, mediaIdx) in file_medias" :key="mediaIdx" class="columns is-mobile is-dekstop is-vcentered post-attachment-item">
              <div class="column is-10 truncated-text">
                <div class="columns is-mobile is-tablet is-desktop is-vcentered is-gapless">
                  <div class="column is-narrow" style="margin-right: 12px;">
                    <icon-collection :media="media" :size="'is-24x24'"></icon-collection>
                  </div>
                  <div class="column">
                    <a href="" class="font-14 font-w-400 has-text-darkblue" @click.prevent="selectMedia(media)">{{ media.name }}</a>
                    <p v-if="!isEmpty(media.size)" class="font-12 font-w-400 has-text-grey2">{{ formatBytes(media.size) }}</p>
                  </div>
                </div>
              </div>
              <div v-if="!isEmpty(auth) && ['O', 'A', 'M'].indexOf(group.groupMemberRole) > -1" class="column is-2">
                <a href="" class="font-14 font-w-500 has-text-primary is-pulled-right" @click.prevent="downloadPostMedia(media)">Unduh</a>
              </div>
            </div>
          </div>
        </div>
        <div v-if="post.type == '1' && !post.teacherQuestion.isGraded" class="columns">
          <div class="column is-full">
            <edl-button
              :variant="'primary'"
              :className="'is-fullwidth'"
              :style="'height: 44px;'"
              @click.native="() => group.type == 'A' ? toDetailPost(post, 'classes', post.groupTeam) : toDetailPost(post, 'groups', post.groupTeam)">
              <span :slot="'text'" class="font-16 font-w-600">{{ group.groupMemberRole == 'O' ? (post.teacherQuestion.isAnswered) ? 'Beri Penilaian' : 'Lihat Detail' : (post.teacherQuestion.isAnswered) ? 'Sudah Dikumpulkan' : (isAfterDueDate(post.teacherQuestion.dueDate)) ? 'Waktu Pengumpulan Selesai' : 'Kumpulkan Tugas' }}</span>
            </edl-button>
          </div>
        </div>
      </div>

      <div v-if="post.type == '1' && post.teacherQuestion.isGraded" style="background-color: #E9F7EC; padding: 16px 20px;">
        <div class="columns is-mobile is-tablet is-dekstop is-vcentered">
          <div class="column is-6">
            <a href="" class="button is-text" @click.prevent="() => {}" style="background: none; cursor: auto;">
              <span class="icon" style="margin-right: 12px;">
                <icon-collection :size="'is-24x24'" :media="{ type: 'image', thumb_url: '/assets/img/icon/circle-check-green-24x24.svg' }" />
              </span>
              <span class="font-18 font-w-500 has-text-primary">Sudah dinilai</span>
            </a>
          </div>
          <div class="column is-6">
            <edl-button
              :variant="'primary-outlined'"
              :class="'is-pulled-right'"
              :style="'border-radius: 6px; padding: 16px 32px; height: 51px;'"
              @click.native="() => group.type == 'A' ? toDetailPost(post, 'classes', post.groupTeam) : toDetailPost(post, 'groups', post.groupTeam)">
              <span :slot="'text'" class="font-16 font-w-600">Lihat Penilaian</span>
            </edl-button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!isEmpty(image_video_medias)">
      <custom-carousel
        style="margin: 10 0 12px;"
        figureStyles="border-radius: 8px;"
        :items="image_video_medias"
        :onPlaying="onVideoPlaying" :onPaused="onPausedVideo" :onBuffer="onVideoBuffer" :onEnded="onEndedVideo"
      ></custom-carousel>
    </div>

    <div v-if="['Z', 'Q', '1'].indexOf(post.type) <= -1" class="middle-content" v-show="!isEmpty(file_medias) && show_attachment_list" style="margin-bottom: 0;">
      <div class="tugas__content-timeline">
        <div class="content" style="padding: 0; border: none;">
          <div class="keterangan" style="margin: 0; width: 100%;">
            <div class="file-download" v-for="(media, key) in file_medias" :key="key" style="padding: 5px .65rem 5px 0;" :style="key == 0 ? 'margin-top: 0 !important;' : 'margin-top: 7px !important;'">
              <span>
                &nbsp;&nbsp;<icon-collection :media="media" size="is-24x24"></icon-collection>
                <a href="" @click.prevent="selectMedia(media)">{{ media.name }}</a>
              </span>
              <button class="button is-text" v-if="!isEmpty(auth) && ['O', 'A', 'M'].indexOf(group.groupMemberRole) > -1" @click.prevent="downloadPostMedia(media)">Unduh</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <hr style="margin: 16px 0px 10px;" v-if="showCommentBox">

    <div class="columns is-vcentered is-mobile" v-if="showCommentBox">
      <div class="column is-narrow" style="padding-right: 0;">
        <a href="" class="button is-text has-text-primary2" @click.prevent="like(post.id, post.like)">
          <b-icon class="animate" style="margin-right: 10px;" :class="{'heartBeat': post.like}" :icon="post.like ? 'heart' : 'heart-outline'" :style="post.like ? 'color: #F50057 !important;' : ''"></b-icon>
          <span class="has-text-primary2 font-14"><strong><span v-if="post.likesCount > 0">{{ post.likesCount }}&nbsp;&nbsp;</span>Suka</strong></span>
        </a>
      </div>
      <div class="column">
        <a href="" class="button is-text" @click.prevent="show_comments = true">
          <span class="icon" style="margin-right: 10px;">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M18.283 8.70703C18.1687 9.59998 17.8629 10.4463 17.3997 11.218C17.422 11.3666 17.4334 11.5163 17.4334 11.6665C17.4334 12.2805 17.2556 12.8689 16.9248 13.4047C16.7564 13.6775 16.7098 13.9892 16.6909 14.1924C16.6694 14.4244 16.6724 14.6756 16.686 14.9152C16.7019 15.1961 16.7342 15.4929 16.7725 15.7753C16.4457 15.6816 16.0952 15.589 15.7632 15.517C15.4981 15.4594 15.226 15.4108 14.9773 15.3877C14.7607 15.3675 14.4405 15.3528 14.1468 15.4478C13.5143 15.6523 12.8178 15.7665 12.0834 15.7665C11.2678 15.7665 10.5162 15.6318 9.85001 15.3959C9.6244 15.4095 9.39653 15.4165 9.16668 15.4165C8.12014 15.4165 7.11456 15.273 6.17773 15.0087C7.49988 16.5897 9.72184 17.5665 12.0834 17.5665C12.989 17.5665 13.8586 17.428 14.6607 17.1732C14.6769 17.1729 14.7235 17.1719 14.8106 17.1799C14.9584 17.1937 15.1523 17.2263 15.3815 17.276C15.8377 17.375 16.3596 17.5254 16.7934 17.6605C17.8183 17.9798 18.8099 17.0878 18.6349 16.0485C18.568 15.6514 18.5049 15.1981 18.4831 14.8136C18.4722 14.6202 18.4732 14.4672 18.4832 14.3587C18.486 14.3291 18.489 14.3075 18.4914 14.2928C18.9622 13.5091 19.2334 12.6167 19.2334 11.6665C19.2334 10.5634 18.883 9.56045 18.283 8.70703Z" fill="#7985CB"/>
              <path fill="white" d="M16.25 7.91667C16.25 10.9082 13.0787 13.3333 9.16665 13.3333C8.12689 13.3333 7.13946 13.162 6.24999 12.8543C5.70792 12.6667 3.91499 13.2856 2.73887 13.7365C2.32994 13.8932 1.90542 13.4907 2.04007 13.074C2.39425 11.9778 2.84254 10.3967 2.62619 10C2.27645 9.35867 2.08332 8.65492 2.08332 7.91667C2.08332 4.92512 5.25463 2.5 9.16665 2.5C13.0787 2.5 16.25 4.92512 16.25 7.91667Z" stroke="#7985CB" stroke-width="1.8"/>
              </svg>

          </span>
          <span class="has-text-primary2 font-14"><strong><span v-if="post.commentCount > 0">{{ post.commentCount }}&nbsp;&nbsp;</span>Komentar</strong></span>
        </a>
      </div>
      <div class="column is-narrow">
        <social-sharing :url="getDetailUrl(post, 'groups')"
          @open="onSharingPopupOpened"
          @close="onSharingPopupClosed"
          :title="post.title"
          :description="shareableDescription(post)"
          :quote="!isEmpty(post.excerpt) ? post.excerpt : post.cleanDescription"
          inline-template>
          <div>
            <b-dropdown hoverable aria-role="list">
              <a href="" class="button is-text" slot="trigger" style="padding-right: 5px;" @click.prevent="">
                <span class="icon" style="margin-right: 10px;">
                  <img src="/assets/img/icon/share.svg" alt="">
                </span>
                <span class="has-text-primary2 font-14"><strong>Bagikan</strong></span>
              </a>

              <b-dropdown-item aria-role="listitem" style="color: #3b5998">
                <network network="facebook">
                  <i class="fab fa-facebook"></i>&nbsp;&nbsp;Facebook
                </network>
              </b-dropdown-item>

              <b-dropdown-item aria-role="listitem" style="color: #0e76a8">
                <network network="linkedin">
                  <i class="fab fa-linkedin"></i>&nbsp;&nbsp;LinkedIn
                </network>
              </b-dropdown-item>

              <b-dropdown-item aria-role="listitem" style="color: #38A1F3">
                <network network="twitter">
                  <i class="fab fa-twitter"></i>&nbsp;&nbsp;Twitter
                </network>
              </b-dropdown-item>

              <b-dropdown-item aria-role="listitem" style="color: #25D366">
                <network network="whatsapp">
                  <i class="fab fa-whatsapp"></i>&nbsp;&nbsp;Whatsapp
                </network>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </social-sharing>
      </div>
      <!-- <div class="column is-narrow">
        <a href="" class="button is-text">
          <span class="icon">
            <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill="white" d="M1.65 3.667C1.65 2.5072 2.5902 1.56699 3.75 1.56699H10.25C11.4098 1.56699 12.35 2.50719 12.35 3.66699V15.5485C12.35 16.0731 11.7241 16.3451 11.3406 15.9871L7.95524 12.8275C7.41736 12.3254 6.58264 12.3254 6.04475 12.8275L2.65939 15.9871C2.27586 16.3451 1.65 16.0731 1.65 15.5485V3.667Z" stroke="#7985CB" stroke-width="1.8"/>
            </svg>
          </span>
        </a>
      </div> -->
    </div>

    <div v-if="show_comments && showCommentLists">
      <comment-box @onReplied="(data) => post.commentCount = data.dataProvider.page.total" :group="group" :post="post" :commentsData="post.comments" :memberId="group.groupMemberId" :disabledComment="!showCommentBox"></comment-box>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { POST, QUIZ, LEARNING_MATERIAL } from '~/consts';
import SHARE_MIXIN from '~/mixins/share';
import POST_MIXINS from '~/mixins/post';
import QUIZ_MIXINS from '~/mixins/quiz';
import COMMENT_MIXIN from '~/mixins/comment';
import Countdown from '~/components/Countdown';
import CommentBox from '~/components/CommentBox';
import moment from 'moment';

export default {
  components: {
    'vcountdown': Countdown,
    CommentBox
  },

  mixins: [SHARE_MIXIN, POST_MIXINS, QUIZ_MIXINS, COMMENT_MIXIN],

  props: {
    group: {
      type: Object,
      required: true
    },
    post: {
      type: Object,
      required: true
    },
    afterSave: {
      type: Function,
      required: false
    },
    afterReply: {
      type: Function,
      default: () => {}
    },
    afterChoose: {
      type: Function,
      default: () => {}
    },
    showCommentLists: {
      type: Boolean,
      default: () => false
    },
    selectMedia: {
      type: Function,
      default: () => {}
    },
    setPosts: {
      type: Function,
      default: () => {}
    },
    setPostsDataProvider: {
      type: Function,
      default: () => {}
    },
    editPost: {
      type: Function,
      default: () => {}
    },
    showCommentBox: {
      type: Boolean,
      default: true
    },
  },

  computed: {
    ...mapState({
      auth: state => state.auth,
      account: state => state.auth.active_pt,
      loading_start_quiz: state => state.quizes.loading_start_quiz,
    }),
    viewed_materials() {
      return this.$store.state.class.viewed_materials[this.group.id]
    },
    counted_comments() {
      return this.post.commentCount;
    },
    medias() {
      let youtubes = [];

      if (!this.isEmpty(this.post.youtube) && !this.isEmpty(this.post.youtube.ids)) {
        youtubes = collect(_.cloneDeep(this.post.youtube.urls)).map((item, key) => {
          return {
            extension: 'youtube',
            link: this.post.youtube.urls,
            mime: 'text/plain',
            name: '',
            ref: {
              youtubeId: this.post.youtube.ids[key]
            },
            type: 'youtube'
          }
        }).toArray()
      }

      return collect(this.post.medias).merge(youtubes).toArray()
    },
    image_video_medias() {
      const vm = this;
      const post = this.post;

      if (!this.isEmpty(post) && !this.isEmpty(this.medias)) {
        return collect(this.medias).filter((media) => {
          return media.type == 'video' || media.type == 'youtube' || media.type == 'image';
        }).map((media) => {
          if (media.type == 'image') {
            return {
              type: media.type,
              link_source: !vm.isEmpty(media.images) && !vm.isEmpty(media.images.original) && !vm.isEmpty(media.images.original.link) && media.storageType == null ? media.images.original.link : (media.storageType == 'google_drive') ? media.values.thumbnailLink : '',
              link_thumb: !vm.isEmpty(media.images) && !vm.isEmpty(media.images.original) && !vm.isEmpty(media.images.original.link) && media.storageType == null ? media.images.original.link : (media.storageType == 'google_drive') ? media.values.thumbnailLink : ''
            }
          } else if (media.type == 'youtube') {
            return {
              type: media.type,
              link_source: media.link,
              youtubeId: media.ref.youtubeId
            }
          } else if (media.type == 'video') {
            return {
              type: media.type,
              link_source: (media.storageType == 'google_drive') ? media.values.downloadLink : !this.isEmpty(media.file) ? media.file.link : null,
              mime: media.mime
            }
          }
        }).toArray();
      }

      return [];
    },
    file_medias() {
      const vm = this;
      const post = this.post;

      if (!this.isEmpty(post) && !this.isEmpty(this.medias)) {
        return collect(this.medias).filter((media) => {
          return media.type == 'document';
        }).toArray();
      }

      return [];
    },
    author() {
      const post = this.post;
      const user = post.user;
      const uu = post.universityUser;
      const avatar_url = !this.isEmpty(user) && !this.isEmpty(user.media) && !this.isEmpty(user.media.images)
        ? user.media.images.thumb.link : null;

      if (this.group.type === 'A' && !this.isEmpty(uu)) {
        return {
          name: uu.name,
          username: uu.username,
          gender: uu.gender,
          role: !this.isEmpty(uu.type) ? uu.type[0] : '',
          avatar_url
        }
      }

      return {
        name: user.name,
        username: user.username,
        gender: user.gender,
        role: '',
        avatar_url
      };
    },
    time_to_run_quiz() {
      const start = moment(this.post.quiz.startedAt);
      const finish = moment(this.post.quiz.finishedAt);

      return finish.diff(start, 'minutes');
    },
    selected_choices: {
      get() {
        return collect(this.post.survey.choices).filter(choice => choice.selected).pluck("id").toArray();
      },
      set() {}
    }
  },

  mounted() {
    $('.dropdown').mouseenter(function () {
      $(this).addClass('is-active');
    }).mouseleave(function () {
      $(this).removeClass('is-active');
    });

    window.addEventListener("scroll", this.onScroll)
  },

  watch: {
    is_visible(val) {
      const vm = this;

      if (val) {
        if (vm.isEmpty(vm.view_interval)) {
          vm.view_interval = setInterval(function () {
            vm.view_timer = vm.view_timer + 1;
          }, 1000)
        }

        if (this.fetch_comments) {
          this.getComments(this.post.id, true);
        }

        switch (this.post.type) {
          case 'Z':
            if (this.fetch_quiz_ranks) {
              this.getPaginatedQuizRank(this.post.quiz.id, true);
            }
            break;
        }
      } else {
        clearInterval(vm.view_interval)
        vm.view_interval = null
        vm.view_timer = 0
      }
    },
    view_timer(val) {
      if (val == this.time_to_track_post) {
        if (this.isEmpty(this.group.groupMemberId)) {
          // this.track('post', 'view_post', this.post.id)
        } else {
          // this.track('post', 'view_post', this.post.id, 'gm', this.group.groupMemberId)
        }
      }
    }
  },

  data() {
    const truncate_limit = 300;
    const truncate_groupname_limit = 15;

    return {
      view_timer: 0,
      view_interval: null,
      is_visible: false,
      truncate_limit,
      truncate_groupname_limit,
      is_truncate: true,
      loading_store_response: false,
      show_attachment_list: true,
      loading_start_meeting: false,
      show_comments: true,
      fetch_quiz_ranks: true,
      fetch_comments: true,
      attachments: [
        { name: 'Template-Pengerjaan-APSI.docx', size: 320, extension: 'docx' },
        { name: 'Format Laporan.pdf', size: 320, extension: 'pdf' },
        { name: 'Video Tutorial', size: 320, extension: 'mp4' },
      ],
    }
  },

  methods: {
    ...mapActions({
      destroyPost: 'posts/destroy',
      playQuiz: 'quizes/startQuiz'
    }),
    async downloadPostMedia(media) {
      if (media.storageType == 'google_drive') {
        await this.downloadFromIntegration(media, true);
      } else {
        await this.download(media, this.post.groupId)
      }

      this.track('post', 'download_media', this.post.id, 'gm', this.group.groupMemberId, {
        media_id: media.id
      })
    },
    onSeeMoreSuccess(res) {
      this.is_truncate = false;
      this.post['description'] = res.data.description
      var box = this.$el.getElementsByClassName('variant-one')[0]
      box.scrollIntoView();
    },
    onScroll(e) {
      const rect = this.$el.getBoundingClientRect();
      let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      this.is_visible = !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    },
    toDetailGroup(post) {
      const vm = this;

      if (['G', 'P', '0', 'D'].indexOf(this.group.type) > -1) {
        window.open(this.group.topicUrl, '_blank');
      } else if (this.group.type == 'U') {
        vm.$router.push({ path: `/panel/university/news` })
      } else if (this.group.type == 'A') {
        vm.$router.push({ path: `/panel/classes/${this.group.id}` })
      } else {
        vm.$router.push({ path: `/panel/groups/${this.group.id}` })
      }
    },
    toDetailPost(post, group_type) {
      const vm = this;

      if (['G', 'P', '0', 'D'].indexOf(this.group.type) > -1) {
        window.open(post.extUrl, '_blank');
      } else if (this.group.type == 'U') {
        vm.$router.push({ path: `/panel/university/news/${post.id}` })
      } else if (!vm.isEmpty(post.section) && ['M', 'Z', 'Q', 'V', '1'].indexOf(post.type) > -1) {
        if (post.type == '1') {
          vm.$router.push({ path: `/panel/${group_type}/${vm.group.id}/groupteams/${post.groupTeam.id}/${post.id}` });
        } else {
          vm.$router.push({ path: `/panel/${group_type}/${vm.group.id}/sections/${post.section.id}/${post.id}` });
        }
      } else {
        vm.$router.push({ path: `/panel/${group_type}/${vm.group.id}/${post.id}` })
      }
    },
    getDetailUrl(post, group_type) {
      const vm = this;
      let host = process.server ? this.$store.app.context.req.headers.host : window.location.host

      if (['G', 'P', '0', 'D'].indexOf(this.group.type) > -1) {
        return post.extUrl;
      } else if (this.group.type == 'U') {
        return host + `/panel/university/news/${post.id}`
      } else if (!vm.isEmpty(post.section) && ['M', 'Z', 'Q', 'V'].indexOf(post.type) > -1) {
        return host + `/panel/${group_type}/${vm.group.id}/sections/${post.section.id}/${post.id}`
      } else {
        return host + `/panel/${group_type}/${vm.group.id}/${post.id}`
      }
    },
    startQuiz(id) {
      this.playQuiz(id);
    },
    autoresize() {
      let el = this.$refs.comment_col;
      let css = 'background-color: #F7F7F7; display: block; overflow: hidden;';

      el.style.cssText = `${css} height:` + el.scrollHeight + `px`;
    },
    edit(post) {
      if (['I', 'S', 'E'].indexOf(post.type) > -1) {
        this.editPost(post)
      } else {
        this.toDetailPost(post, this.group.type == 'A' ? 'classes' : 'groups')
      }
    },
    checkCapabilities() {
      if (this.isEmpty(this.group.groupMemberRole) || (this.group.groupMemberRole == 'GUEST')) {
        toast.error('Akses anda dibatasi, gabung ke grup terlebih dahulu');

        throw new Error('Akses anda dibatasi, gabung ke grup terlebih dahulu');
      }
    },
    addChoice(survey, choice) {
      const vm = this;

      this.checkCapabilities();

//    Prevent brute force
      if (vm.loading_store_response) {
        return;
      }

      const postData = {
        surveyType: survey.surveyType,
        choiceId: choice.id,
        isChecked: choice.selected ? 0 : 1 // reverse from selected
      };

      if (vm.group.type === 'A') {
        postData['university_user_id'] = vm.account.id;
      }

      vm.loading_store_response = true;

      this.$axios.post(POST.ADD_SURVEY_RESPONSE(vm.group.id, survey.id), postData)
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            vm.post.survey['choices'] = data.data;

            Vue.nextTick(() => {
              vm.loading_store_response = false;
            });
          } else {
            toast.danger(data.applicationSystem.message);
          }
        }).catch(() => {
          vm.loading_store_response = false;
          toast.danger('Terjadi kesalahan pada sistem');
        });
    },
    capitalize(text) {
      return helpers.capitalize(text);
    },
    getDay(date) {
      return moment(date).format('D');
    },
    getMonth(date) {
      date = moment(date).format('MMM');
      return this.capitalize(date);
    },
    getYear(date) {
      return moment(date).format('YYYY');
    },
    getFormattedDate(date) {
      date = moment(date);
      return `${this.capitalize(date.format('dddd'))}, ${this.capitalize(date.format('Do'))} ${this.capitalize(date.format("MMMM YYYY, HH:mm"))}`;
    },
    roundNumeric(float) {
      return !isNaN(float) ? parseFloat(Math.round(float * 100) / 100) : 0;
    },
    isEmpty(item) {
      return helpers.isEmpty(item);
    },
    isImage(media) {
      return !this.isEmpty(media.mime) ? media.mime.split('/')[0] == 'image' : false;
    },
    startMeeting() {
      const vm = this;

      if (vm.loading_start_meeting) {
        return;
      }

      vm.loading_start_meeting = true

      this.$axios.post(LEARNING_MATERIAL.START_MEETING, {
        id: this.post.id
      }, {
        timeout: 20000
      }).then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          if (!vm.isEmpty(data.applicationSystem.message)) {
            vm.$buefy.dialog.confirm({
              title: 'Informasi',
              message: data.applicationSystem.message,
              type: 'is-info',
              cancelText: 'Batal',
              confirmText: 'Lanjutkan',
              hasIcon: true,
              onConfirm: () => {
                window.open(data.data.startUrl, '_blank');
              }
            })
          } else {
            window.open(data.data.startUrl, '_blank');
          }
        } else {
          toast.danger(data.applicationSystem.message);
        }

        vm.loading_start_meeting = false
      }).catch(() => {
        vm.loading_start_meeting = false
      })
    },
    onSharingPopupOpened() {

    },
    onSharingPopupClosed() {
      this.track('post', 'share_post', this.post.id)
    },
    onPausedVideo(e, duration) {
      if (['M'].indexOf(this.group.groupMemberRole) > -1) {
        this.onVideoPaused(e, duration, this.post.id, this.group.groupMemberId);
      }
    },
    onEndedVideo(e, duration) {
      if (['M'].indexOf(this.group.groupMemberRole) > -1) {
        this.onVideoEnded(e, duration, this.post.id, this.group.groupMemberId);
      }
    },
    onLikeSuccess(liked) {
      this.post['like'] = liked

      if (!liked) {
        this.post['likesCount'] = this.post.likesCount > 0 ? this.post.likesCount - 1 : 0;
      } else {
        this.post['likesCount'] = this.post.likesCount + 1;
      }
    },
    onGetPaginatedQuizRankSuccess(res, refresh) {
      let ranks = res.data.data

      if (!refresh) {
        ranks = this.quiz_ranks.concat(ranks)
      }

      this.quiz_ranks = ranks;
      this.quizRankDataProvider = res.data.dataProvider
      this.fetch_quiz_ranks = false
    },
    onGetCommentsSuccess(res) {
      this.post['comments'] = res.data.data
      this.fetch_comments = false
    },
    fetchQuizRanks() {
      this.getPaginatedQuizRank(this.post.quiz.id, false)
    },
    onDeletedPost(data, id) {
      const vm = this

      if (data.applicationSystem.code == 0) {
        vm.$emit('getPosts', true)

        toast.default(data.applicationSystem.message);
      } else {
        toast.danger(data.applicationSystem.message);
      }
    },
    filterSymbol(text) {
      const toArray = text.split(" ");
      const filter = toArray.filter(txt => txt != "&amp;");
      return filter.join(" ");
    },
    openAuthorPage() {
      if (this.post.type === "G") {
        window.open('https://www.goodnewsfromindonesia.id', "_blank");
      } else if (this.post.type === "P") {
        window.open('https://campuspedia.id', "_blank");
      } else if (this.post.type === "0") {
        window.open('https://sevima.com', "_blank");
      } else if (this.post.type === "D") {
        window.open('https://duniadosen.com', "_blank");
      } else if (!this.isEmpty(this.post.user) && !this.isEmpty(this.post.user.email)) {
        this.$router.push({ name: "profile-username", params: { username: this.post.user.email }});
      }
    },
    isAfterDueDate(due_date) {
      if (this.isEmpty(due_date)) {
        return false;
      }

      const due_at = moment(due_date)
      const now = moment()

      return now.isAfter(due_at)
    }
  }
}
</script>

<style lang="scss">
.timeline-content.content {
  margin-bottom: 10px !important;

  pre {
    ul {
      background: #ebebeb;
      font-style: italic;
      padding: 20px 40px;
    }

    ul, figure.image, .content figure {
      margin-left: 0;
      margin-right: 0;
      width: auto !important;
    }

    figure.image figcaption {
      color: #8a8a8a;
    }
  }
}

.comment {
  padding: 8px;
  background-color: #fafafa;
  border: 1px solid #E5E5E5;
  margin-bottom: 10px;
  border-radius: 3px;
}

.pre-comment {
  background: none;
  padding: 0 !important;
  font-family: inherit;
  white-space: pre-line !important;
}
</style>
